
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react";
import App from './App.tsx'
import './index.css'

Sentry.init({
  dsn: "https://8a37ec87ced3d16acde3be10cbd32e8b@o4509500403351552.ingest.us.sentry.io/4509500564570112",
  environment: import.meta.env.MODE || 'development',
  
  // Release information for source map matching
  release: import.meta.env.VITE_SENTRY_RELEASE || `${import.meta.env.VITE_APP_VERSION || '1.0.0'}-${Date.now()}`,
  
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
    Sentry.feedbackIntegration({
      colorScheme: "light",
    }),
  ],
  
  // Configure Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  
  // Adjust sample rates based on environment
  tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
  
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/dcalavwuedknvuofvttt\.supabase\.co/],
  
  // Enhanced error filtering for production
  beforeSend(event) {
    // Filter out common development errors in production
    if (import.meta.env.MODE === 'production') {
      // Filter out chunk loading errors that are often non-critical
      if (event.exception?.values?.[0]?.value?.includes('Loading chunk')) {
        return null;
      }
      
      // Filter out network errors that might be temporary
      if (event.exception?.values?.[0]?.value?.includes('NetworkError')) {
        return null;
      }
    }
    
    return event;
  },
  
  // Add user context
  initialScope: {
    tags: {
      component: "admin-dashboard",
    },
  },
});

createRoot(document.getElementById("root")!).render(<App />);
